import { inject, Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { AppSessionService } from '../app-session/app-session.service';
import { Observable } from 'rxjs';
import { JwtAuth } from '../../models/jwt-auth';
import { ApiService } from '../api/api.service';
import { Session } from '../../models/session';

const AUTH_URL = `${environment.service.url}/api/auth/saml/soo`;
const USERNAME = environment.service.jwt.username;
const PASSWORD = environment.service.jwt.password;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly _api = inject(ApiService);
  private readonly _appSessionService = inject(AppSessionService);

  private _logginOut: boolean = false;

  /**
   * Get loggin out flag when user click the login out action.
   */
  public get logginOut(): boolean {
    return this._logginOut;
  }

  /**
   * Get system user logged in session.
   */
  public get session(): Session {
    return this._appSessionService.session!;
  }

  /**
   * Redirect the user to login with SecureAuth and SAML.
   */
  public login = (): void => {
    this._appSessionService.removeSession();
    window.location.href = `${AUTH_URL}/login`;
  };

  /**
   * Logout current logged in user.
   */
  public logout = (): void => {
    this._logginOut = true;
    this._appSessionService.removeSession();
    window.location.href = `${AUTH_URL}/logout`;
  };

  /**
   * Generate a one time use jwt access token.
   * @returns Observable with JwtAuth model.
   */
  public generateJwtAccessToken$(): Observable<JwtAuth> {
    return this._api.post$('auth', 'jwt/login', {
      'username': USERNAME,
      'password': PASSWORD,
      'azureUserId': this.session.adid
    }) as Observable<JwtAuth>;
  }

  /**
   * Get logged in SystemUser session claims.
   * @returns Observable with Session model but only with claims values.
   */
  public getSystemUserLoggedInSessionClaims$(): Observable<Session> {
    return this._api.get$('auth', 'session/me') as Observable<Session>;
  }
}